import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'uploadingFileStatusToNumber'
})
export class UploadingFileStatusToNumberPipe implements PipeTransform {

  transform(value: any): number {
    let sum = 0;
    if (Object.keys(value).length > 0) {
      Object.keys(value).forEach(v => {
        sum += value[v].type === 'dicom-folder' ? (value[v].uploading * 0.4) + (value[v].compressing * 0.2) + (value[v].anonymizing * 0.2) + (value[v].processing * 0.2) : (value[v].uploading * 0.7) + (value[v].processing * 0.3);
      });
      return (sum / Object.keys(value).length) * 100;
    } else {
      return 0;
    }
  }

}
